import { ShellLogger } from '@sennder/shell-utilities'
import { loggerInstance } from '.'

export const logger = new ShellLogger(
  {
    module: 'otters-shell',
    codeOwners: 'frontend-systems',
  },
  () => loggerInstance
)
